import type { Lucid } from '../../types/types';

const isAbsoluteURLRegex = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;

/** Checks if the url starts with either `http://,https://,www` */
const isAbsoluteURL = (url: string): url is Lucid.Generic.AbsoluteURL => {
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www') || isAbsoluteURLRegex.test(url))
    return true;

  return false;
};

export default isAbsoluteURL;
